import request from '@/utils/request';

/**
 * 获取卡券商品列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 * @param {string} params.productName - 商品名称（模糊查询）
 * @param {string} params.status - 状态 0:下架 1:上架
 */
export function getCardCouponList(params) {
  return request({
    url: '/admin/parking/card/list',
    method: 'GET',
    params: params
  });
}

/**
 * 获取卡券商品详情
 * @param {number} id - 商品ID
 */
export function getCardCouponDetail(id) {
  return request({
    url: "/admin/parking/card/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 新增卡券商品
 * @param {Object} data - 商品数据
 */
export function addCardCoupon(data) {
  return request({
    url: '/admin/parking/card/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑卡券商品
 * @param {Object} params - 商品数据
 */
export function updateCardCoupon(data) {
  return request({
    url: '/admin/parking/card/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除卡券商品
 * @param {number} id - 商品ID
 */
export function deleteCardCoupon(id) {
  return request({
    url: "/admin/store/cardCoupon/delete/".concat(id),
    method: 'GET'
  });
}

/**
 * 上架卡券商品
 * @param {number} id - 商品ID
 */
export function putOnShelfCardCoupon(id) {
  return request({
    url: "/admin/parking/card/putOnShell/".concat(id),
    method: 'GET'
  });
}

/**
 * 下架卡券商品
 * @param {number} id - 商品ID
 */
export function offShelfCardCoupon(id) {
  return request({
    url: "/admin/parking/card/offShell/".concat(id),
    method: 'GET'
  });
}

/**
 * 复制卡券商品
 * @param {number} id - 商品ID
 */
export function copyCardCoupon(id) {
  return request({
    url: "/admin/store/cardCoupon/copy/".concat(id),
    method: 'GET'
  });
}

/**
 * 获取调价记录
 * @param {number} parkingCardId - 停车卡ID
 */
export function getPriceAdjustmentRecords(parkingCardId) {
  return request({
    url: '/admin/parking/card/price/log',
    method: 'GET',
    params: {
      parkingCardId: parkingCardId
    }
  });
}

/**
 * 获取公司列表（用于使用人群选择）
 * @param {string} keyword - 搜索关键词
 */
export function getCompanyList(keyword) {
  console.log('getCompanyList', keyword);
  return request({
    url: '/admin/business/company/autoList',
    method: 'GET',
    params: {
      keyword: keyword || ''
    }
  });
}

/**
 * 获取停车场列表（自动补全）
 * @param {string} keyword - 搜索关键词
 */
export function getParkingLotList(keyword) {
  console.log('getParkingLotList', keyword);
  return request({
    url: '/admin/parking/lot/autocomplete',
    method: 'GET',
    params: {
      keyword: keyword || ''
    }
  });
}

/**
 * 获取福卡列表（用于福卡选择）
 * @param {string} keyword - 搜索关键词
 */
export function getFucardList(keyword) {
  console.log('getFucardList', keyword);
  var params = {
    keyword: keyword || ''
  };
  console.log('params', params);
  return request({
    url: '/admin/fudou/fucard/select',
    method: 'get',
    params: params
  });
}